import { useState } from "react";
import secureLocalStorage from "react-secure-storage";
import FileUpload from "../../../utils/FileUpload";
import "./settings.css";

const ImportBulkData = () => {
  const slsRole = secureLocalStorage.getItem("role");

  const [isCollapsed, setIsCollapsed] = useState(false);
  const [collapseClass, setCollapseClass] = useState("");
  const toggleCollapse = () => {
    if (collapseClass === "show") {
      setCollapseClass("");
    } else {
      setCollapseClass("show");
    }
    setIsCollapsed(!isCollapsed);
  };
  return (
    <div className="all-content settingsContainer">
      <div className="all-table-holder importBulkDataContainer">
        <div
          id="importBulkData"
          className="importBulkDataWrap"
        >
          <FileUpload role={slsRole} />
        </div>
      </div>
    </div>
  );
};

export default ImportBulkData;
